document.addEventListener('DOMContentLoaded', function() {
    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    // Required inputs
    let forms = document.querySelectorAll('.gform_wrapper form');
    forms.forEach((form) => {
        form.removeAttribute('novalidate');
    });
    let formelems = document.querySelectorAll(
        '.gfield_contains_required input, .gfield_contains_required textarea, .gfield_contains_required select');
    formelems.forEach((formelem) => {
        formelem.required = true;
    });

    // What is being said slider component init
    if (document.querySelector('.what-is-being-said-splide')) {
        var whatIsBeingSaidSlider = new Splide('.what-is-being-said-splide', {
            fixedWidth: isMobile ? 300 : 940,
            gap: isMobile ? 24 : 40,
            arrows: false,
            autoHeight: true,
        });
        whatIsBeingSaidSlider.mount();
    }

    // Offers slider component init
    if (document.querySelector('.offers_slider_wrapper')) {
        var slideWidth = isMobile ? 300 : 400;
        var slideGap = isMobile ? 16 : 40;
        var offersSlider = new Splide('.offers_slider', {
            fixedWidth: slideWidth,
            gap: slideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        offersSlider.mount();
        var _Components = offersSlider.Components,
            offersController = _Components.Controller, Move = _Components.Move;
        var prevButton = document.querySelector(
            '.offers_slider_wrapper .prev_button');
        prevButton.style.display = 'none';
        prevButton.addEventListener('click', function() {
            var maxPosition = Math.min(Move.getPosition() +
                slideWidth +
                slideGap, 0);
            offersController.scroll(maxPosition);
        });
        var nextButton = document.querySelector(
            '.offers_slider_wrapper .next_button');
        nextButton.addEventListener('click', function() {
            var minPosition = Math.max(Move.getPosition() -
                slideWidth -
                slideGap, Move.getLimit(true));
            offersController.scroll(minPosition);
        });
        offersSlider.on('moved', hideArrows);
        offersSlider.on('scrolled', hideArrows);

        function hideArrows() {
            var position = Move.getPosition();
            var limit = Move.getLimit(true);
            if (position >= 0) {
                prevButton.style.display = 'none';
            } else {
                prevButton.style.display = 'inline-flex';
            }
            if (position <= limit) {
                nextButton.style.display = 'none';
            } else {
                nextButton.style.display = 'inline-flex';
            }
        }
    }

    // additional_services_slider_wrapper slider component init
    if (document.querySelector('.additional_services_slider_wrapper')) {
        var slideWidth = isMobile ? 300 : 400;
        var slideGap = isMobile ? 16 : 40;
        var additionalSlider = new Splide('.additional_services_slider', {
            fixedWidth: slideWidth,
            gap: slideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        additionalSlider.mount();
        var _Components = additionalSlider.Components,
            additionalController = _Components.Controller,
            Move = _Components.Move;
        var additionalprevButton = document.querySelector(
            '.additional_services_slider_wrapper .prev_button');
        additionalprevButton.style.display = 'none';
        additionalprevButton.addEventListener('click', function() {
            var maxPosition = Math.min(Move.getPosition() +
                slideWidth +
                slideGap, 0);
            additionalController.scroll(maxPosition);
        });
        var additionalnextButton = document.querySelector(
            '.additional_services_slider_wrapper .next_button');
        additionalnextButton.addEventListener('click', function() {
            var minPosition = Math.max(Move.getPosition() -
                slideWidth -
                slideGap, Move.getLimit(true));
            additionalController.scroll(minPosition);
        });
        additionalSlider.on('moved', hideArrows);
        additionalSlider.on('scrolled', hideArrows);

        function hideArrows() {
            var position = Move.getPosition();
            var limit = Move.getLimit(true);
            if (position >= 0) {
                additionalprevButton.style.display = 'none';
            } else {
                additionalprevButton.style.display = 'inline-flex';
            }
            if (position <= limit) {
                additionalnextButton.style.display = 'none';
            } else {
                additionalnextButton.style.display = 'inline-flex';
            }
        }
    }

    // Events slider component init
    if (document.querySelector('.events_slider_wrapper')) {
        var slideWidth = isMobile ? 300 : 400;
        var slideGap = isMobile ? 16 : 40;
        var eventsSlider = new Splide('.events_slider', {
            fixedWidth: slideWidth,
            gap: slideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        eventsSlider.mount();
        var _Components = eventsSlider.Components,
            Controller = _Components.Controller, Move = _Components.Move;
        var prevButton = document.querySelector(
            '.events_slider_wrapper .prev_button');
        prevButton.style.display = 'none';
        prevButton.addEventListener('click', function() {
            var maxPosition = Math.min(Move.getPosition() +
                slideWidth +
                slideGap, 0);
            Controller.scroll(maxPosition);
        });
        var nextButton = document.querySelector(
            '.events_slider_wrapper .next_button');
        nextButton.addEventListener('click', function() {
            var minPosition = Math.max(Move.getPosition() -
                slideWidth -
                slideGap, Move.getLimit(true));
            Controller.scroll(minPosition);
        });
        eventsSlider.on('moved', hideArrows);
        eventsSlider.on('scrolled', hideArrows);

        function hideArrows() {
            var position = Move.getPosition();
            var limit = Move.getLimit(true);
            if (position >= 0) {
                prevButton.style.display = 'none';
            } else {
                prevButton.style.display = 'inline-flex';
            }
            if (position <= limit) {
                nextButton.style.display = 'none';
            } else {
                nextButton.style.display = 'inline-flex';
            }
        }
    }

    // News slider component init
    if (document.querySelector('.news_slider_wrapper')) {
        var newsslideWidth = isMobile ? 300 : 400;
        var newsslideGap = isMobile ? 16 : 40;
        var newsSlider = new Splide('.news_slider', {
            fixedWidth: newsslideWidth,
            gap: newsslideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        newsSlider.mount();
        var _newsComponents = newsSlider.Components,
            newsController = _newsComponents.Controller,
            newsMove = _newsComponents.Move;
        var newsprevButton = document.querySelector(
            '.news_slider_wrapper .prev_button');
        newsprevButton.style.display = 'none';
        newsprevButton.addEventListener('click', function() {
            var newsmaxPosition = Math.min(newsMove.getPosition() +
                newsslideWidth +
                newsslideGap, 0);
            newsController.scroll(newsmaxPosition);
        });
        var newsnextButton = document.querySelector(
            '.news_slider_wrapper .next_button');
        newsnextButton.addEventListener('click', function() {
            var newsminPosition = Math.max(newsMove.getPosition() -
                newsslideWidth -
                newsslideGap, newsMove.getLimit(true));
            newsController.scroll(newsminPosition);
        });
        newsSlider.on('moved', hideNewsArrows);
        newsSlider.on('scrolled', hideNewsArrows);

        function hideNewsArrows() {
            var newsposition = newsMove.getPosition();
            var newslimit = newsMove.getLimit(true);
            if (newsposition >= 0) {
                newsprevButton.style.display = 'none';
            } else {
                newsprevButton.style.display = 'inline-flex';
            }
            if (newsposition <= newslimit) {
                newsnextButton.style.display =
                    'none';
            } else {
                newsnextButton.style.display = 'inline-flex';
            }
        }

    }

    // Rooms slider component init
    if (document.querySelector('.rooms_slider_wrapper')) {
        var roomsslideWidth = isMobile ? 300 : 400;
        var roomsslideGap = isMobile ? 16 : 40;
        var roomsSlider = new Splide('.rooms_slider', {
            fixedWidth: roomsslideWidth,
            gap: roomsslideGap,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        roomsSlider.mount();
        var _roomsComponents = roomsSlider.Components,
            roomsController = _roomsComponents.Controller,
            roomsMove = _roomsComponents.Move;
        var roomsprevButton = document.querySelector(
            '.rooms_slider_wrapper .prev_button');
        roomsprevButton.style.display = 'none';
        roomsprevButton.addEventListener('click', function() {
            var roomsmaxPosition = Math.min(roomsMove.getPosition() +
                roomsslideWidth +
                roomsslideGap, 0);
            roomsController.scroll(roomsmaxPosition);
        });
        var roomsnextButton = document.querySelector(
            '.rooms_slider_wrapper .next_button');
        roomsnextButton.addEventListener('click', function() {
            var roomsminPosition = Math.max(roomsMove.getPosition() -
                roomsslideWidth -
                roomsslideGap, roomsMove.getLimit(true));
            roomsController.scroll(roomsminPosition);
        });
        roomsSlider.on('moved', hideRoomsArrows);
        roomsSlider.on('scrolled', hideRoomsArrows);

        function hideRoomsArrows() {
            var roomsposition = roomsMove.getPosition();
            var roomslimit = roomsMove.getLimit(true);
            if (roomsposition >= 0) {
                roomsprevButton.style.display = 'none';
            } else {
                roomsprevButton.style.display = 'inline-flex';
            }
            if (roomsposition <= roomslimit) {
                roomsnextButton.style.display =
                    'none';
            } else {
                roomsnextButton.style.display = 'inline-flex';
            }
        }
    }

    // Rooms slider component init
    if (document.querySelector('.rooms_slider_wrapper2')) {
        var roomsslideWidth2 = isMobile ? 300 : 400;
        var roomsslideGap2 = isMobile ? 16 : 40;
        var roomsSlider2 = new Splide('.rooms_slider2', {
            fixedWidth: roomsslideWidth2,
            gap: roomsslideGap2,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        roomsSlider2.mount();
        var _roomsComponents2 = roomsSlider2.Components,
            roomsController2 = _roomsComponents2.Controller,
            roomsMove2 = _roomsComponents2.Move;
        var roomsprevButton2 = document.querySelector(
            '.rooms_slider_wrapper2 .prev_button');
        roomsprevButton2.style.display = 'none';
        roomsprevButton2.addEventListener('click', function() {
            var roomsmaxPosition2 = Math.min(roomsMove2.getPosition() +
                roomsslideWidth2 +
                roomsslideGap2, 0);
            roomsController2.scroll(roomsmaxPosition2);
        });
        var roomsnextButton2 = document.querySelector(
            '.rooms_slider_wrapper2 .next_button');
        roomsnextButton2.addEventListener('click', function() {
            var roomsminPosition2 = Math.max(roomsMove2.getPosition() -
                roomsslideWidth2 -
                roomsslideGap2, roomsMove2.getLimit(true));
            roomsController2.scroll(roomsminPosition2);
        });
        roomsSlider2.on('moved', hideRoomsArrows2);
        roomsSlider2.on('scrolled', hideRoomsArrows2);

        function hideRoomsArrows2() {
            var roomsposition2 = roomsMove2.getPosition();
            var roomslimit2 = roomsMove2.getLimit(true);
            if (roomsposition2 >= 0) {
                roomsprevButton2.style.display = 'none';
            } else {
                roomsprevButton2.style.display = 'inline-flex';
            }
            if (roomsposition2 <= roomslimit2) {
                roomsnextButton2.style.display =
                    'none';
            } else {
                roomsnextButton2.style.display = 'inline-flex';
            }
        }
    }

    // Rooms slider component init
    if (document.querySelector('.rooms_slider_wrapper3')) {
        var roomsslideWidth3 = isMobile ? 300 : 400;
        var roomsslideGap3 = isMobile ? 16 : 40;
        var roomsSlider3 = new Splide('.rooms_slider3', {
            fixedWidth: roomsslideWidth3,
            gap: roomsslideGap3,
            arrows: false,
            pagination: false,
            autoHeight: true,
        });
        roomsSlider3.mount();
        var _roomsComponents3 = roomsSlider3.Components,
            roomsController3 = _roomsComponents3.Controller,
            roomsMove3 = _roomsComponents3.Move;
        var roomsprevButton3 = document.querySelector(
            '.rooms_slider_wrapper3 .prev_button');
        roomsprevButton3.style.display = 'none';
        roomsprevButton3.addEventListener('click', function() {
            var roomsmaxPosition3 = Math.min(roomsMove3.getPosition() +
                roomsslideWidth3 +
                roomsslideGap3, 0);
            roomsController3.scroll(roomsmaxPosition3);
        });
        var roomsnextButton3 = document.querySelector(
            '.rooms_slider_wrapper3 .next_button');
        roomsnextButton3.addEventListener('click', function() {
            var roomsminPosition3 = Math.max(roomsMove3.getPosition() -
                roomsslideWidth3 -
                roomsslideGap3, roomsMove3.getLimit(true));
            roomsController3.scroll(roomsminPosition3);
        });
        roomsSlider3.on('moved', hideRoomsArrows3);
        roomsSlider3.on('scrolled', hideRoomsArrows3);

        function hideRoomsArrows3() {
            var roomsposition3 = roomsMove3.getPosition();
            var roomslimit3 = roomsMove3.getLimit(true);
            if (roomsposition3 >= 0) {
                roomsprevButton3.style.display = 'none';
            } else {
                roomsprevButton3.style.display = 'inline-flex';
            }
            if (roomsposition3 <= roomslimit3) {
                roomsnextButton3.style.display =
                    'none';
            } else {
                roomsnextButton3.style.display = 'inline-flex';
            }
        }
    }

    // Hero slider
    document.querySelectorAll('.hero-slider').forEach((element) => {
        new Splide(element, {
            perPage: 1,
            pagination: false,
            arrows: false,
            autoplay: true,
            type: 'fade',
            rewind: true,
            speed: 1000,
            autoplaySpeed: 1000,
            pauseOnHover: false,
        }).mount();
    });

    // Top slider
    document.querySelectorAll('.top-layout').forEach((element) => {
        new Splide(element, {
            perPage: 1,
            pagination: false,
            arrows: false,
            autoplay: true,
            type: 'fade',
            rewind: true,
            speed: 1000,
            autoplaySpeed: 1000,
            pauseOnHover: false,
        }).mount();
    });

    // Burger menu
    {
        var appHeader = document.querySelector('.app_header');
        var megaMenuElement = document.querySelector('.mega-menu');
        var burgerMenuElement = document.querySelector('.burger_menu');
        var burgerButton = document.querySelector('.burger_button');
        var burgerCloseButtons = document.querySelectorAll('.close_burger');
        // Mega menu
        if (appHeader) {
            burgerCloseButtons.forEach(function(_closeButton) {
                _closeButton.addEventListener('click', closeBurgerMenu);
            });
            // burgerButton
            burgerButton.addEventListener('click', openBurgerMenu);
        }

        function openBurgerMenu() {
            megaMenuElement.classList.add('-translate-y-full');
            burgerMenuElement.classList.remove('translate-x-full');
            document.body.classList.add('overflow-hidden');
        }

        function closeBurgerMenu() {
            burgerMenuElement.classList.add('translate-x-full');
            document.body.classList.remove('overflow-hidden');
        }

        document.addEventListener('click', function(e) {
            if (!burgerButton.contains(e.target) &&
                !burgerMenuElement.contains(e.target)) {
                closeBurgerMenu();
            }
        });
        // Burger submenus
        document.querySelectorAll('.main_burger_menu > .menu-item-has-children')
            .forEach(function(menuItem) {
                menuItem.querySelector('a')
                    .addEventListener('click', function(e) {
                        e.stopPropagation();
                    });
                menuItem.querySelector('div')
                    .addEventListener('click', function() {
                        menuItem.classList.toggle('open');
                    });
            });
    }

    // Menu Dropdown (Mod w/ .open state)
    if (window.location.hash) {
        var hash = window.location.hash.substring(1);
        if (document.getElementById(hash)) {
            setTimeout(function() {
                document.getElementById(hash).click();
            }, 500);
        }
    }
    {
        var dropdownWrappers = document.querySelectorAll(
            '.menu-dropdown-wrapper');

        dropdownWrappers.forEach(function(dropdownWrapper) {
            var dropdown = dropdownWrapper.querySelector('.dropdown');
            var button = dropdownWrapper.querySelector('.dropdown-button');
            var height = dropdown.clientHeight;
            var isOpen = false;

            if (dropdownWrapper.classList.contains('open')) {
                dropdown.style.height = height;
                isOpen = true;
            } else {
                dropdown.style.height = 0;
            }

            button.addEventListener('click', function() {
                if (isOpen) {
                    dropdownWrapper.classList.remove('open');
                    dropdown.style.height = 0;
                    isOpen = false;

                } else {
                    dropdownWrapper.classList.add('open');
                    dropdown.style.height = height + 'px';
                    isOpen = true;
                }
            });
        });
    }

    document.querySelectorAll('.header_menu_item').forEach(function(menuItem) {

        var interval;

        menuItem.addEventListener('mouseleave', function(event) {
            interval = setInterval(function() {
                menuItem.classList.remove('over');

            }, 300);
        });

        menuItem.addEventListener('mouseover', function(event) {
            menuItem.classList.add('over');

            if (interval) {
                clearInterval(interval);
            }
        });

    });

});

function CopyMe(TextToCopy) {
    var TempText = document.createElement('input');
    TempText.value = TextToCopy;
    document.body.appendChild(TempText);
    TempText.select();

    document.execCommand('copy');
    document.body.removeChild(TempText);

    alert('Kod kopierad: ' + TempText.value);
}

//# sourceMappingURL=activities.ecbe73e0.js.map

jQuery(document).ready(function($) {
    'use strict';

    // Hotel page main slider
    if (document.querySelector('.hotel-page-slider')) {
        var hotelPageSlider = new Splide('.hotel-page-slider', {
            pagination: false,
            type: 'loop',
            autoHeight: true,
        });
        hotelPageSlider.mount();
    }

    // Meeting room slider
    $('.meeting-rooms-slider').each(function(index) {
        $(this).addClass('meeting-rooms-slider-' + index);
        $(this)
            .find('.splide__arrow--prev')
            .addClass('splide__arrow--prev-' + index);
        $(this)
            .find('.splide__arrow--next')
            .addClass('splide__arrow--next-' + index);
        var meetingRoomSlider = '.meeting-rooms-slider-' + index;
        new Splide(meetingRoomSlider, {
            pagination: false,
            type: 'loop',
            autoHeight: true,
            classes: {
                prev: 'splide__arrow--prev-' + index,
                next: 'splide__arrow--next-' + index,
            },
        }).mount();
    });

    // heart-of-runo-slider
    if (document.querySelector('.heart-of-runo-slider')) {
        var heartOfRunoSlider = new Splide('.heart-of-runo-slider', {
            pagination: false,
            type: 'loop',
            autoHeight: true,
        });
        heartOfRunoSlider.mount();
    }

    // event-slider
    if (document.querySelector('.event-slider')) {
        var eventSlider = new Splide('.event-slider', {
            pagination: false,
            type: 'loop',
            autoHeight: true,
        });
        eventSlider.mount();
    }

    // wedding-slider
    if (document.querySelector('.wedding-slider')) {
        var weddingSlider = new Splide('.wedding-slider', {
            pagination: false,
            type: 'loop',
            autoHeight: true,
        });
        weddingSlider.mount();
    }

});

// scroll classes in body

document.addEventListener('DOMContentLoaded', function() {
    let lastScrollTop = 0;
    const scrollThreshold = 500;

    window.addEventListener('scroll', function() {
        let scrollTop = window.pageYOffset ||
            document.documentElement.scrollTop;

        if (scrollTop > scrollThreshold) {
            if (scrollTop > lastScrollTop) {
                document.body.classList.add('scroll', 'scroll-down');
                document.body.classList.remove('scroll-up');
            } else {
                document.body.classList.add('scroll', 'scroll-up');
                document.body.classList.remove('scroll-down');
            }
        } else {
            document.body.classList.remove(
                'scroll',
                'scroll-down',
                'scroll-up',
            );
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // För att undvika negativa scrollvärden
    });
});

// Add arrows to submenu if needed

(function(w) {
    function checkOverflow() {
        const btn_left = document.getElementById('btn-left'),
            btn_right = document.getElementById('btn-right'),
            content = document.getElementById('con');

        if (content) {
            const activeItem = content.querySelector('.current_page_item');
            if (activeItem) {
                content.scrollLeft =
                    activeItem.offsetLeft - content.offsetLeft - 50;
            }
            const content_scroll_width = content.scrollWidth;
            const content_client_width = content.clientWidth;

            // Check if content overflows
            if (content_scroll_width > content_client_width) {
                btn_left.classList.add('!flex');
                btn_right.classList.add('!flex');
            } else {
                btn_left.classList.remove('!flex');
                btn_right.classList.remove('!flex');
            }

        }

    }

    w.addEventListener('load', function() {
        checkOverflow();

        const btn_left = document.getElementById('btn-left'),
            btn_right = document.getElementById('btn-right'),
            content = document.getElementById('con');
        if (content) {
            let content_scroll_left = content.scrollLeft;

            btn_right.addEventListener('click', () => {
                content_scroll_left += 200;
                const max_scroll_left = content.scrollWidth -
                    content.clientWidth;
                if (content_scroll_left >= max_scroll_left) {
                    content_scroll_left = max_scroll_left;
                }
                content.scrollTo({
                    left: content_scroll_left,
                    behavior: 'smooth',
                });
            });

            btn_left.addEventListener('click', () => {
                content_scroll_left -= 200;
                if (content_scroll_left <= 0) {
                    content_scroll_left = 0;
                }
                content.scrollTo({
                    left: content_scroll_left,
                    behavior: 'smooth',
                });
            });
        }

    });

    w.addEventListener('resize', checkOverflow);
})(window);
